// Opciones de IndicadorFacturacion para Item
const INDICADOR_FACTURACION_LIST = [
  { value: 0, label: "No Facturable" },
  { value: 1, label: "ITBIS 18%" },
  { value: 2, label: "ITBIS 16%" },
  { value: 3, label: "ITBIS 0%" },
  { value: 4, label: "Exento" },
  { value: 5, label: "ITBIS 18% del 10%" },
];

// Opciones de IndicadorBienOServicio para Item
const INDICADOR_BIEN_O_SERVICIO_LIST = [
  { value: 1, label: "Bien" },
  { value: 2, label: "Servicio" },
];

// Opciones de Indicador para MetodoPago
const INDICADOR_METODO_PAGO_LIST = [
  { value: 1, label: "Efectivo" },
  { value: 2, label: "Cheque/Transferencia/Depósito" },
  { value: 3, label: "Tarjeta de Crédito/Tarjeta de Débito" },
  { value: 4, label: "Venta a Crédito" },
  { value: 5, label: "Bono/Certificado" },
  { value: 6, label: "Permuta" },
  { value: 7, label: "Nota de Crédito" },
  { value: 8, label: "Otras formas de pago" },
];

// Opciones de TipoDocumento para Cliente
const TIPO_DOCUMENTO_LIST = [
  { value: "R", label: "RNC" },
  { value: "C", label: "Cédula" },
  { value: "P", label: "Pasaporte" },
];

// Opciones de Tipo de Comprobante para Cliente
const TIPO_COMPROBANTE_LIST = [
  { value: "F", label: "Crédito Fiscal" },
  { value: "C", label: "Consumo" },
  { value: "G", label: "Gubernamental" },
  { value: "E", label: "Exportaciones" },
  { value: "P", label: "Pagos al Exterior" },
  { value: "R", label: "Régimen Especial" },
  { value: "CP", label: "Compras" },
];

export class CargaMasiva {
  /**
   * Configuración de entidades disponibles para la carga masiva.
   * Cada campo define: key (nombre del campo en el DTO), label (cabecera),
   * type (text|number|select), required, options (para select).
   */
  static get ENTIDADES() {
    return [
      {
        value: "Cliente",
        label: "Clientes",
        descripcion: "Compradores del sistema",
        icono: "team",
        iconSize: "52",
        campos: [
          { key: "RazonSocial", label: "Nombre", type: "text", required: true },
          {
            key: "Documento",
            label: "Documento",
            type: "text",
            required: true,
            validate: (val, fila) => {
              if (!val) return null;
              if (fila.TipoDocumento !== "P") {
                if (!/^\d{9}$|^\d{11}$/.test(val))
                  return "El Documento debe tener 9 o 11 caracteres y solo números.";
              }
              return null;
            },
          },
          {
            key: "TipoDocumento",
            label: "Tipo Documento",
            type: "select",
            required: true,
            options: TIPO_DOCUMENTO_LIST,
          },
          {
            key: "Tipo",
            label: "Tipo Comprobante",
            type: "select",
            required: true,
            options: TIPO_COMPROBANTE_LIST,
            validate: (val, fila) => {
              if (!val) return null;
              if (fila.TipoDocumento === "P" && val !== "C" && val !== "E")
                return "No puede asignar el Tipo de Documento Pasaporte a un Cliente que utilice un Tipo de Comprobante Fiscal distinto a Consumo.";
              return null;
            },
          },
          { key: "Direccion", label: "Dirección", type: "text", required: false },
          { key: "Contacto", label: "Teléfono", type: "text", required: false },
          {
            key: "Email",
            label: "Email",
            type: "text",
            required: false,
            validate: (val) => {
              if (!val || val.trim() === "") return null;
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              const emails = val.split(",").map((e) => e.trim()).filter(Boolean);
              for (const email of emails) {
                if (!emailRegex.test(email))
                  return `El email ${email} debe tener un formato válido.`;
              }
              return null;
            },
          },
          { key: "CodigoInternoComprador", label: "Código Interno", type: "text", required: false },
        ],
        requestKey: "Clientes",
      },
      {
        value: "Vendedor",
        label: "Vendedores",
        descripcion: "Personal de ventas",
        icono: "user",
        campos: [
          { key: "Nombre", label: "Nombre", type: "text", required: true },
          { key: "ClaveVendedor", label: "Clave Vendedor", type: "text", required: false },
        ],
        requestKey: "Vendedores",
      },
      {
        value: "Item",
        label: "Items",
        descripcion: "Productos y servicios del catálogo",
        icono: "item",
        campos: [
          { key: "Nombre", label: "Nombre", type: "text", required: true },
          { key: "Descripcion", label: "Descripción", type: "text", required: false },
          {
            key: "IndicadorFacturacion",
            label: "Tipo ITBIS",
            type: "select",
            required: true,
            options: INDICADOR_FACTURACION_LIST,
            validate: (val) => {
              const n = Number(val);
              if (isNaN(n) || n < 0 || n > 5)
                return "El indicador de facturación debe ser un número entre 0 y 5.";
              return null;
            },
          },
          {
            key: "IndicadorBienOServicio",
            label: "Bien/Servicio",
            type: "select",
            required: true,
            options: INDICADOR_BIEN_O_SERVICIO_LIST,
          },
          {
            key: "PrecioUnitario",
            label: "Precio Unitario",
            type: "number",
            required: true,
            min: 0,
            validate: (val) => {
              const n = Number(val);
              if (!isNaN(n) && n < 0)
                return "El precio unitario no puede ser negativo.";
              return null;
            },
          },
          { key: "CodigoBarra", label: "Código de Barra", type: "text", required: false },
          { key: "CategoriaIdSec", label: "Categoría (Id)", type: "number", required: false },
        ],
        requestKey: "Items",
      },
      {
        value: "Categoria",
        label: "Categorías",
        descripcion: "Categorías de items",
        icono: "category",
        campos: [
          { key: "Nombre", label: "Nombre", type: "text", required: true },
        ],
        requestKey: "Categorias",
      },
      {
        value: "MetodoPago",
        label: "Formas de Pago",
        descripcion: "Formas de pago configuradas",
        icono: "forma-pago",
        iconSize: "52",
        campos: [
          { key: "Nombre", label: "Nombre", type: "text", required: true },
          {
            key: "Indicador",
            label: "Tipo de Pago",
            type: "select",
            required: true,
            options: INDICADOR_METODO_PAGO_LIST,
          },
        ],
        requestKey: "MetodosPago",
      },
    ];
  }

  /** Devuelve la configuración de una entidad por su value */
  static getConfigEntidad(value) {
    return CargaMasiva.ENTIDADES.find((e) => e.value === value) || null;
  }

  /**
   * Valida una fila de datos en el cliente.
   * Devuelve null si es válida, o un string con el mensaje de error.
   */
  static validarFila(entidadValue, fila) {
    const config = CargaMasiva.getConfigEntidad(entidadValue);
    if (!config) return "Entidad no reconocida.";

    for (const campo of config.campos) {
      if (campo.required) {
        const val = fila[campo.key];
        if (val === null || val === undefined || val === "") {
          return `El campo "${campo.label}" es requerido.`;
        }
      }
      if (campo.type === "number" && fila[campo.key] !== "" && fila[campo.key] !== null && fila[campo.key] !== undefined) {
        const num = Number(fila[campo.key]);
        if (isNaN(num)) {
          return `El campo "${campo.label}" debe ser numérico.`;
        }
        if (campo.min !== undefined && num < campo.min) {
          return `El campo "${campo.label}" no puede ser menor a ${campo.min}.`;
        }
      }
      if (campo.type === "select" && campo.options) {
        const val = fila[campo.key];
        const valStr = val === null || val === undefined ? "" : String(val);
        const esValido = campo.options.some((o) => String(o.value) === valStr);
        if (!esValido) {
          return `El campo "${campo.label}" tiene un valor no válido.`;
        }
      }
      if (campo.validate) {
        const val = fila[campo.key];
        const errorCustom = campo.validate(val, fila);
        if (errorCustom) return errorCustom;
      }
    }
    return null;
  }

  /** Construye el body del request de guardar a partir de la entidad y las filas */
  static buildGuardarRequest(entidadValue, filas) {
    const config = CargaMasiva.getConfigEntidad(entidadValue);
    if (!config) return null;
    return {
      Entidad: entidadValue,
      [config.requestKey]: filas,
    };
  }
}
